import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { TIconsLabel } from 'src/app/_helpers/iconsBaseMaps'
import { GOOGLE_API_KEY } from 'src/app/app.api'
import { Company } from 'src/app/models/Company'
import { NearPins } from 'src/app/models/PinsFromMapView'
import { Region } from 'src/app/models/Region'
import { CompanyService } from 'src/app/services/company.service'
import { NotificationService } from 'src/app/services/notification.service'
import { RegionsService } from 'src/app/services/regions.service'

@Component({
	selector: 'app-map-schedule-view',
	templateUrl: './map-schedule-view.componenet.html'
})
export class MapScheduleView implements OnInit, OnChanges {

	constructor(
		public notificationService: NotificationService,
		private companyService: CompanyService,
		private readonly regionsService: RegionsService
	) { }

	@Input() public nearPins: Array<NearPins> = []
	@Input() public legendMap: TIconsLabel = null
		@Input() public latitude: number = 0
		@Input() public longitude: number = 0
		@Input() public draggable: boolean = false
	@Input() public updateSwitch: boolean = false
	@Input() public showTakePhoto: boolean = false
	@Input() public screenShotCompleted: boolean = false
	@Input() public enableNearMarkersMode: boolean = false

		@Output() public dragged: EventEmitter<{
		latitude: number,
		longitude: number,
		street: string
	}> = new EventEmitter()
	@Output() public googleImageUrl: EventEmitter<{
		url: string
	}> = new EventEmitter()
	@Output() public getNearMarkers: EventEmitter<{
		lat: number,
		lng: number
	}> = new EventEmitter()
	@Output() public getDetailNear: EventEmitter<string> = new EventEmitter()

		public myMap: google.maps.Map
	public marker: google.maps.Marker = new google.maps.Marker()
	public nearMarkers: Array<google.maps.Marker> = []
		public polygonsDelimitAllRegions: Array<google.maps.Polygon> = []
	public regionInfoWindow = new google.maps.InfoWindow()
	public modeMap: 'normal' | 'streetView' = 'normal'
		public viewAllRegionsInMap: boolean = true

	public companyId: string = localStorage.getItem('companyId')
	public company: Company = new Company()
	public allRegions: Array<Region> = []
	public companyLat: number = 0
	public companyLng: number = 0

		public async ngOnInit(): Promise<void> {
		await this.fetchCompany()
		await this.fetchRegions()
		await this.setLatLng()
	 await this.initMap()

		if (this.allRegions.length > 0) {
						this.insertShowRegionsButtonInGooleMaps()
						this.createAllRegions()
			   this.showAllRegionsInMap()
				}

		if (this.nearPins && this.legendMap) {
			await this.addNearMarkers()
		}
		}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.updateSwitch) {
			this.updatePinLocation()
		}
		if (changes.screenShotCompleted) {
			this.printingView()
		}
		if (changes.nearPins && this.legendMap) {
			this.addNearMarkers()
		}
	}

		public initMap() {
				const mapView = document.getElementById('map-details')

		  let lat: number = 0
		  let lng: number = 0

		  if (this.latitude == 0 || this.longitude == 0) {
			lat = this.companyLat
			lng = this.companyLng
		} else {
			lat = this.latitude
			lng = this.longitude
		}

		  const position = new google.maps.LatLng(
						lat,
						lng
				)

		  const map: google.maps.Map = new google.maps.Map(mapView, {
			zoom: 14,
			center: position,
			gestureHandling: 'cooperative'
		})

		  map.setOptions({
			styles: [
				{
					featureType: 'poi',
					stylers: [
						{ visibility: 'off' }
					]
				},
				{
					featureType: 'transit.station.bus',
					stylers: [
						{ visibility: 'off' }
					]
				}
			]
		})

		  this.myMap = map

		  this.setPositionMarker(position)

		  if (this.showTakePhoto) {
			this.setControllerTakePhotoInNormalMap()
			this.setControllerTakePhotoInStreetView()
		}

		  if (this.legendMap) {
			this.insertLegendInMap()
		}

		  map.addListener('click', () => {
						this.regionInfoWindow.close()
				})
		}

		public setPositionMarker(position: google.maps.LatLng) {
		const iconBase: string = 'assets/images/m1.svg'
		const map = this.myMap

		this.marker.setMap(null)

		this.marker = new google.maps.Marker({
			position,
			icon: iconBase,
			map,
			animation: google.maps.Animation.DROP,
			draggable: this.draggable
		})

	 this.marker.addListener('dragend', event => {
			this.dragedPin(event.latLng)

			if (this.enableNearMarkersMode) {
				this.getNearMarkers.emit({
					lat: event.latLng.lat(),
					lng: event.latLng.lng()
				})
			}
		})

		this.myMap.setCenter(position)
		this.myMap.setZoom(14)

		console.clear()
	}

	public setControllerTakePhotoInNormalMap() {

		const iconBase: string = 'assets/images/icon/cam-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const button = document.createElement('button')

		const handleClickButton = () => {
			this.takePhoto('normal')
		}

		button.setAttribute('class', 'btn-google-maps')
		button.appendChild(svgIcon)

		button.addEventListener('click', () => {
			handleClickButton()
		})

		if (this.legendMap) {
			this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(button)
			button.classList.add('capture-simple')
		} else {
			this.myMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(button)
			button.insertAdjacentHTML('beforeend', 'Capturar imagem')
		}
	}

	public setControllerTakePhotoInStreetView() {
		const iconBase: string = 'assets/images/icon/cam-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const streetViewButton = document.createElement('button')

		const handleClickButton = () => {
			this.takePhoto('streetView')
		}

		streetViewButton.setAttribute('class', 'btn-google-maps streetView')
		streetViewButton.appendChild(svgIcon)
		streetViewButton.insertAdjacentHTML('beforeend', 'Capturar imagem')

		streetViewButton.addEventListener('click', () => {
			handleClickButton()
		})

		const streetView = this.myMap.getStreetView()
		streetView.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(streetViewButton)
	}

	public takePhoto(modeMap: 'normal' | 'streetView') {

		this.modeMap = modeMap

		const urlGoogle = this.returnLinkImage()

		this.googleImageUrl.emit({
			url: urlGoogle
		})
	}

	public returnLinkImage(): string {
		this.disableTakePhotoButton(true)

		let urlImage = ''

		if (this.modeMap === 'normal') {

			const zoom = this.myMap.getZoom()
			const position = this.myMap.getCenter()
			const latitude = position.lat()
			const longitude = position.lng()

			const isSatelliteMode: boolean = Boolean(
				this.myMap.getMapTypeId() === google.maps.MapTypeId.HYBRID ||
				this.myMap.getMapTypeId() === google.maps.MapTypeId.SATELLITE
			)

			urlImage = isSatelliteMode ?
						`https://maps.googleapis.com/maps/api/staticmap?size=1920x1080
						&center=${latitude},${longitude}
						&zoom=${zoom}
						&maptype=satellite
						&markers=color:red%7C${latitude},${longitude}
						&key=${GOOGLE_API_KEY}` :

						`https://maps.googleapis.com/maps/api/staticmap?size=1920x1080
						&center=${latitude},${longitude}
						&zoom=${zoom}
						&markers=color:red%7C${latitude},${longitude}
						&key=${GOOGLE_API_KEY}`

		} else if (this.modeMap === 'streetView') {
			const streetView = this.myMap.getStreetView()

			const zoom = streetView.getZoom()
			const pov = streetView.getPov()
			const position = streetView.getPosition()
			const latitude = position.lat()
			const longitude = position.lng()

			urlImage = `https://maps.googleapis.com/maps/api/streetview?size=1920x1080
						&location=${latitude},${longitude}
						&heading=${pov.heading}
						&pitch=${pov.pitch}
						&fov=${90 / Math.pow(1.2, zoom - 1)}
						&key=${GOOGLE_API_KEY}`
		}

		return urlImage
	}

	public disableTakePhotoButton(disabled: boolean) {
		let takePhotoButton: HTMLButtonElement

		if (this.modeMap === 'normal') {

			takePhotoButton =
				this.myMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].getAt(0) as HTMLButtonElement

			if (!disabled) this.myMap.controls[google.maps.ControlPosition.TOP_LEFT].removeAt(0)

		} else if (this.modeMap === 'streetView') {

			const streetView = this.myMap.getStreetView()

			takePhotoButton =
				streetView.controls[google.maps.ControlPosition.LEFT_BOTTOM].getAt(0) as HTMLButtonElement

			if (!disabled) streetView.controls[google.maps.ControlPosition.TOP_LEFT].removeAt(0)
		}

		takePhotoButton.disabled = disabled
	}

		public async dragedPin(latlng) {
		const geocoder: google.maps.Geocoder = new google.maps.Geocoder()
		geocoder.geocode({ location: latlng }, (results, status) => {
			if (status === google.maps.GeocoderStatus.OK) {
				this.dragged.emit({
					street: results[0].formatted_address,
										latitude: results[0].geometry.location.lat(),
										longitude: results[0].geometry.location.lng()
								})
			}
		})
	}

	public updatePinLocation() {
		let lat: number = 0
		let lng: number = 0

		if (this.latitude == 0 || this.longitude == 0) {
			lat = this.companyLat
			lng = this.companyLng
		} else {
			lat = this.latitude
			lng = this.longitude
		}

		const position = new google.maps.LatLng(
						lat,
						lng
				)

		this.setPositionMarker(position)
	}

	public printingView() {

		const windowPrinting = document.createElement('div')
		windowPrinting.setAttribute('class', 'window-printing')

		const modalConfirm = document.createElement('div')
		modalConfirm.setAttribute('class', 'popup-confirm')

		const iconBase: string = 'assets/images/icon/success-icon.svg'
		const svgIcon = document.createElement('img')
		svgIcon.setAttribute('src', iconBase)

		const handleClickButton = () => {
			this.disableTakePhotoButton(false)
		}

		const buttonConfirm = document.createElement('button')
		buttonConfirm.setAttribute('class', 'btn-primary')
		buttonConfirm.innerText = 'Fechar'

		buttonConfirm.addEventListener('click', () => {
			handleClickButton()
		})

		modalConfirm.appendChild(svgIcon)
		modalConfirm.insertAdjacentHTML('beforeend', 'Captura feita com sucesso!')
		modalConfirm.appendChild(buttonConfirm)

		windowPrinting.appendChild(modalConfirm)

		if (this.modeMap === 'normal') {

			this.myMap.controls[google.maps.ControlPosition.TOP_LEFT].push(windowPrinting)

		} else if (this.modeMap === 'streetView') {

			const streetView = this.myMap.getStreetView()
			streetView.controls[google.maps.ControlPosition.TOP_LEFT].push(windowPrinting)
		}
	}

	public async fetchCompany(): Promise<void> {
		try {
			const response: Company = await this.companyService
				.detailCompany(this.companyId)
				.toPromise()
			this.company = response
		} catch (err) { }
	}

	public async setLatLng() {
		const geocoder: google.maps.Geocoder = new google.maps.Geocoder()
		await geocoder.geocode({ address: this.company.address.street }, async (results, status) => {
			if (status === google.maps.GeocoderStatus.OK) {
				this.companyLat = results[0].geometry.location.lat()
				this.companyLng = results[0].geometry.location.lng()
			}
		})
	}

	public async fetchRegions() {
		try {
			this.allRegions =
				await this.regionsService.getRegionsFromMapByCompanyId(this.companyId).toPromise()
		} catch (err) { }
	}

	public insertShowRegionsButtonInGooleMaps() {
				const iconBase: string = 'assets/images/icon/hide-icon.svg'
		  const svgIcon = document.createElement('img')
				svgIcon.setAttribute('id', 'img-show-all-regions')
		  svgIcon.setAttribute('src', iconBase)

		  const button = document.createElement('button')

				const handleClickButton = () => {
						this.viewAllRegionsInMap = !this.viewAllRegionsInMap
			   this.switchShowHideRegionsInMap()
						this.updateImageButtonShowHideRegions()
		}

		  button.setAttribute('class', 'btn-google-maps regions-button in-schedule')
		  button.appendChild(svgIcon)

		  button.addEventListener('click', () => {
			handleClickButton()
		})

		  this.myMap.controls[google.maps.ControlPosition.RIGHT_TOP].push(button)
		}

	public createAllRegions() {
				this.allRegions.forEach(region => {
						const polygon = new google.maps.Polygon({
				strokeOpacity: 0.6,
				strokeWeight: 2,
				fillColor: region.color,
				fillOpacity: 0.5,
				paths: region.coordinates
			})

			   polygon.addListener('click', event => {
				const clickLatLng = event.latLng

				if (!this.regionInfoWindow) {
					this.regionInfoWindow = new google.maps.InfoWindow()
				}

				this.regionInfoWindow.setContent(region.name)
				this.regionInfoWindow.setPosition(clickLatLng)
				this.regionInfoWindow.open(this.myMap)
			})

			   this.polygonsDelimitAllRegions.push(polygon)
				})
		}

	public switchShowHideRegionsInMap() {
				if (this.viewAllRegionsInMap) {
						this.showAllRegionsInMap()
				} else {
						this.hideAllRegionsInMap()
				}
		}

		public showAllRegionsInMap() {
				this.polygonsDelimitAllRegions.forEach(poligon => {
						poligon.setMap(this.myMap)
				})
		}

		public hideAllRegionsInMap() {
				this.polygonsDelimitAllRegions.forEach(poligon => {
						poligon.setMap(null)
				})

		  this.regionInfoWindow.close()
		}

	public updateImageButtonShowHideRegions() {
				const iconBase: string =
						`assets/images/icon/${this.viewAllRegionsInMap ? 'hide-icon' : 'show-icon'}.svg`

				const imageButton: HTMLImageElement =
						document.getElementById('img-show-all-regions') as HTMLImageElement

				if (imageButton) {
						imageButton.setAttribute('src', iconBase)
				}
		}

	public insertLegendInMap() {

		const legend = document.createElement('div')
		legend.setAttribute('class', 'legend-map')

		for (const key in this.legendMap) {

			const type = this.legendMap[key]
		 const name = type.name
		 const icon = `${ type.icon}.svg`

		 const legendItem = document.createElement('div')
		 legendItem.setAttribute('class', 'legend-item')
		 legendItem.innerHTML = `<img src="${icon}"> <span>${name}</span>`
		 legend.appendChild(legendItem)

			this.myMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend)
				}
	}

	public addNearMarkers() {
		if (this.nearMarkers.length > 0) {
			this.nearMarkers.forEach(marker => marker.setMap(null))
			this.nearMarkers.length = 0
		}

		const map = this.myMap

		this.nearPins.forEach(pin => {
			const positionMap = new google.maps.LatLng(
				Number(pin.lat),
				Number(pin.lng)
			)

			const marker: google.maps.Marker = new google.maps.Marker({
				position: positionMap,
				icon: `${this.legendMap[pin.type].icon}.png`,
				map,
				animation: google.maps.Animation.DROP
			})

			marker.addListener('click', () => {
				this.getDetailNear.emit(pin.idMongo)
			})

			this.nearMarkers.push(marker)
		})
	}
}
